import React, { memo } from 'react';

import { Icon, Text, Spacer, useTheme } from '@Sage/hoi-poi-ui';

import AbsoluteLoader from 'components/AbsoluteLoader';
import useLoginLiterals from 'utils/literals/useLoginLiterals';

import './styles.scss';

const UnsubscribedSuccessful = memo(() => {
    const theme = useTheme();
    const { loading, getLiteral } = useLoginLiterals();

    if (loading) {
        return (
            <div className="unsubscribe-successful">
                <AbsoluteLoader size="massive" />
            </div>
        );
    }

    const title = getLiteral('label_unsubscribe_success');
    const description = getLiteral('label_unsubscribe_description');

    return (
        <div className="unsubscribe-successful">
            <div className="unsubscribe-successful__content">
                <Spacer y={3} />
                <Icon
                    name="taskCheckedOutline"
                    color={theme.colors.semantic.positive500}
                    size="huge"
                />
                <Spacer y={2} />
                <Text type="h6">{title}</Text>
                <Spacer y={2} />
                <Text type="body" color={theme.colors.textLight.secondary}>
                    {description}
                </Text>
            </div>
        </div>
    );
});

UnsubscribedSuccessful.displayName = 'UnsubscribedSuccessful';

export default UnsubscribedSuccessful;
